export const selectEvents = (reduxState) => reduxState.events.events;
export const selectEventsLoading = (reduxState) => reduxState.events.loading;
